const calculateTimestamp = (timestamp: number | null = null) => {
    let date = new Date();

    if (timestamp) {
        date = new Date(timestamp);
    }

    const day = date.toLocaleString('en-US', { weekday: 'short' }); // e.g. "Thu"
    const month = date.toLocaleString('en-US', { month: 'short' }); // e.g. "Jan"
    const dayOfMonth = date.getDate(); // e.g. 16

    // Get hours, minutes, seconds in 24-hour format
    const year = String(date.getFullYear());
    const hours = String(date.getHours()).padStart(2, '0'); // e.g. "16"
    const minutes = String(date.getMinutes()).padStart(2, '0'); // e.g. "43"
    const seconds = String(date.getSeconds()).padStart(2, '0'); // e.g. "21"

    return `${hours}:${minutes}:${seconds} on ${day}, ${month} ${dayOfMonth}, ${year}`;
};

const getCreationTimestamp = () => {
    return new Date().getTime() + new Date().getTimezoneOffset() * 60000;
};

const generateTimestamp = (timestamp: number | null = null) => {
    if (timestamp) {
        const now = new Date().getTime() + new Date().getTimezoneOffset() * 60000;
        const diffMs = now - timestamp;

        if (diffMs < 0) {
            // Edge case: timestamp is in the future
            return 'Just now';
        }

        const diffSeconds = Math.floor(diffMs / 1000);
        const diffMinutes = Math.floor(diffSeconds / 60);

        // If difference <= 59 minutes 59 seconds
        if (diffMinutes < 60) {
            // If it's under 60 seconds, say "X seconds ago"
            if (diffMinutes === 0) {
                const seconds = diffSeconds === 0 ? 1 : diffSeconds;
                return `${seconds}s ago`;
            }
            return `${diffMinutes}m ago`;
        }

        return calculateTimestamp(timestamp);
    }

    return calculateTimestamp();
};

export { getCreationTimestamp, generateTimestamp };
